'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _Functions = require('../core/Functions');

var _colors = require('HubStyleTokens/colors');

var _Styles = require('../utils/Styles');

var _TileContext = require('../context/TileContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var compactTileContext = { compact: true };

var spacedMixin = (0, _styledComponents.css)(['.private-tile + &{margin-top:16px;}']);

var Tile = _styledComponents2.default.div.withConfig({
  displayName: 'UITile__Tile'
})(['position:relative;', ';background-color:', ';border:1px solid ', ';', ';', ''], _Styles.setBorderRadius, _colors.OLAF, _colors.GREAT_WHITE, function (_ref) {
  var distance = _ref.distance;
  return distance && (0, _Styles.setDistance)(distance);
}, function (_ref2) {
  var distance = _ref2.distance;
  return !distance && spacedMixin;
});

var CloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'UITile__CloseButton'
})(['right:12px;top:12px;']);

var UITile = _react2.default.createClass({
  displayName: 'UITile',

  propTypes: {
    children: _react.PropTypes.node.isRequired,
    closeable: _react.PropTypes.bool.isRequired,
    compact: _react.PropTypes.bool.isRequired,
    distance: _react.PropTypes.oneOf(_Styles.DISTANCE_KEYS),
    onClose: _react.PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      compact: false
    };
  },
  handleCloseButtonClick: function handleCloseButtonClick(evt) {
    (0, _Functions.callIfPossible)(this.props.onClose, evt);
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        closeable = _props.closeable,
        compact = _props.compact,
        __onClose = _props.onClose,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'closeable', 'compact', 'onClose']);

    return _react2.default.createElement(
      _TileContext.TileContextProvider,
      {
        value: compact ? compactTileContext : _TileContext.defaultTileContext
      },
      _react2.default.createElement(
        Tile,
        _extends({}, rest, { className: (0, _classNames2.default)('private-tile', className) }),
        closeable ? _react2.default.createElement(CloseButton, {
          color: _colors.FLINT,
          onClick: this.handleCloseButtonClick,
          size: 'small'
        }) : null,
        children
      )
    );
  }
});

exports.default = UITile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tile/UITile.js
// module id = 142
// module chunks = 3 4